import { Controller } from "@hotwired/stimulus"
import CartEntrySummaryStore from "../stores/cart_entry_summary_store"

export default class extends Controller {
  updateFromStore() {
    this.element.innerHTML = CartEntrySummaryStore.isEmpty ? null : CartEntrySummaryStore.cartEntriesCount()
  }
}
